import React from "react";
import { Reveal } from "@/components/Reveal";
import PageHead from "@/components/PageHead";

const SECTIONS = [
  {
    h: "Acceptance of terms",
    p: "By accessing or using citirex.com (the \"Site\") you agree to be bound by these Terms of Service. If you do not agree, do not use the Site.",
  },
  {
    h: "Nature of the service",
    p: "Citirex is a B2B performance marketing agency. The Site is informational and is intended for prospective business partners. The Site does not collect consumer lead data and Citirex is not a licensed insurance producer, broker or agent. Citirex does not sell insurance directly to consumers.",
  },
  {
    h: "Intellectual property",
    p: "All content on the Site — including copy, design, graphics, logos and code — is owned by Citirex LLC or its licensors and is protected by U.S. and international intellectual property laws. No portion of the Site may be reproduced without written permission.",
  },
  {
    h: "Acceptable use",
    p: "You agree not to: (i) misuse the Site or interfere with its operation, (ii) attempt to access non-public areas of the Site or its systems, (iii) scrape, frame, or otherwise extract content programmatically without permission, or (iv) use the Site to transmit unlawful, infringing or harmful material.",
  },
  {
    h: "Third-party partnerships",
    p: "Citirex contracts with carriers, agencies, IMOs, FMOs and contractors. Any partnership is governed by a separate written agreement. Nothing on the Site constitutes an offer or binding commitment to enter into such a partnership.",
  },
  {
    h: "Disclaimers",
    p: "The Site is provided on an \"as-is\" basis. Citirex disclaims all warranties, express or implied, including merchantability, fitness for a particular purpose and non-infringement. Statistics, benchmarks and testimonials on the Site are illustrative and do not constitute a guarantee of results.",
  },
  {
    h: "Limitation of liability",
    p: "To the maximum extent permitted by law, Citirex's aggregate liability arising out of or relating to your use of the Site is limited to one hundred U.S. dollars ($100). Citirex is not liable for any indirect, consequential, incidental or punitive damages.",
  },
  {
    h: "Governing law",
    p: "These Terms are governed by the laws of the State of California, without regard to its conflict-of-laws principles. Exclusive jurisdiction and venue lie in the state or federal courts located in Los Angeles County, California.",
  },
  {
    h: "Contact",
    p: "Legal inquiries should be submitted through the contact form on citirex.com/contact. Citirex LLC, 15165 Ventura Blvd, Suite 225, Sherman Oaks, CA 91403.",
  },
];

export default function Terms() {
  return (
    <main data-testid="terms-page">
      <PageHead
        title="Terms of Service"
        description="Terms governing the use of citirex.com — Citirex LLC's corporate B2B marketing site."
        path="/terms"
      />
      <section className="border-b border-citirex-border bg-citirex-bg">
        <div className="mx-auto max-w-7xl px-6 pb-16 pt-12 md:px-12 md:pb-24 md:pt-20">
          <Reveal>
            <p className="overline">Legal</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="mt-6 max-w-5xl font-display text-5xl font-semibold leading-[0.95] tracking-tighter md:text-7xl lg:text-[96px]">
              Terms of{" "}
              <span className="font-editorial italic font-normal text-citirex-accent">
                Service
              </span>
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-body text-sm uppercase tracking-[0.2em] text-citirex-sub">
              Last updated · December 2025
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-citirex-bg">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-24 md:grid-cols-12 md:px-12 md:py-32">
          <div className="md:col-span-4">
            <p className="overline">Contents</p>
            <ol className="mt-6 space-y-2 border-t border-citirex-border pt-6">
              {SECTIONS.map((s, i) => (
                <li
                  key={s.h}
                  className="flex items-baseline gap-3 font-body text-sm text-citirex-ink"
                >
                  <span className="font-editorial italic text-citirex-sub">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {s.h}
                </li>
              ))}
            </ol>
          </div>
          <div className="md:col-span-8">
            <div className="border-t border-citirex-border">
              {SECTIONS.map((s, i) => (
                <article
                  key={s.h}
                  className="border-b border-citirex-border py-10"
                >
                  <p className="font-editorial text-3xl italic text-citirex-accent">
                    {String(i + 1).padStart(2, "0")}
                  </p>
                  <h2 className="mt-3 font-display text-2xl font-medium text-citirex-ink md:text-3xl">
                    {s.h}
                  </h2>
                  <p className="mt-4 font-body text-base leading-relaxed text-citirex-sub md:text-lg">
                    {s.p}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
